(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "react", "@blueprintjs/core", "../../../../utils/translate"], b);else if ("undefined" != typeof exports) b(exports, require("react"), require("@blueprintjs/core"), require("../../../../utils/translate"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.react, a.core, a.translate), a.LoginFormRenderer = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d) {
  "use strict";

  var e = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.LoginFormRenderer = void 0, b = e(b), d = e(d);

  var f = function f(_ref) {
    var a = _ref.submit,
        e = _ref.setLogin,
        f = _ref.setPassword,
        g = _ref.errorLogin,
        h = _ref.errorPassword,
        i = _ref.errorGeneric,
        _ref$translate = _ref.translate,
        j = _ref$translate === void 0 ? (0, d.default)({
      "auth.loginform.email.helper": "Type your email",
      "auth.loginform.email.helper_invalid": "Invalid email",
      "auth.loginform.email.label": "Email",
      "auth.loginform.email.info": "required",
      "auth.loginform.email.placeholder": "Email",
      "auth.loginform.password.helper": "Type your password",
      "auth.loginform.password.helper_invalid": "Invalid password",
      "auth.loginform.password.label": "Password",
      "auth.loginform.password.info": "required",
      "auth.loginform.password.placeholder": "Password",
      "auth.loginform.submit": "Signin",
      "auth.loginform.error_generic": "Invalid credentials"
    }) : _ref$translate;
    return b.default.createElement(c.Card, {
      className: "login-form"
    }, i && b.default.createElement(c.Callout, {
      className: "login-form__callout",
      intent: c.Intent.DANGER
    }, j("auth.loginform.error_generic")), b.default.createElement("form", {
      onSubmit: a
    }, b.default.createElement(c.FormGroup, {
      helperText: j("auth.loginform.email.helper", {
        context: g ? "invalid" : "help"
      }),
      label: j("auth.loginform.email.label"),
      labelFor: "login",
      labelInfo: j("auth.loginform.email.info"),
      intent: g ? c.Intent.WARNING : null
    }, b.default.createElement(c.InputGroup, {
      type: "email",
      id: "login",
      placeholder: j("auth.loginform.email.placeholder"),
      onChange: e,
      intent: g ? c.Intent.WARNING : null,
      autoComplete: "username"
    })), b.default.createElement(c.FormGroup, {
      helperText: j("auth.loginform.password.helper", {
        context: h ? "invalid" : "help"
      }),
      label: j("auth.loginform.password.label"),
      labelFor: "password",
      labelInfo: j("auth.loginform.password.info"),
      intent: h ? c.Intent.WARNING : null
    }, b.default.createElement(c.InputGroup, {
      type: "password",
      id: "password",
      placeholder: j("auth.loginform.password.placeholder"),
      onChange: f,
      intent: h ? c.Intent.WARNING : null,
      autoComplete: "current-password"
    })), b.default.createElement(c.Button, {
      type: "submit"
    }, j("auth.loginform.submit"))));
  };

  a.LoginFormRenderer = f;
  a.default = f;
});